import React from 'react';
import MaterialUiTheme from 'config/MaterialUiTheme';
import Routes from './Routes';
import GlobalStyles from './GlobalStyles.styles';
import { RecoilRoot } from 'recoil';
import { ApolloProvider } from '@apollo/client';
import ApolloClient from 'services/graphql';
import DatePickersLocalizationProvider from 'config/DatePickersLocalizationProvider';
import DayJsConfig from 'config/dayjs';
import { SnackbarProvider } from 'notistack';

function App() {
  return (
    <RecoilRoot>
      <ApolloProvider client={ApolloClient}>
        <DayJsConfig />
        <DatePickersLocalizationProvider>
          <MaterialUiTheme>
            <GlobalStyles />
            <SnackbarProvider anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}>
              <Routes />
            </SnackbarProvider>
          </MaterialUiTheme>
        </DatePickersLocalizationProvider>
      </ApolloProvider>
    </RecoilRoot>
  );
}

export default App;
